import { getDashboard, setKvkk } from "@/services/dashboard.service";

// initial state
const state = () => ({
  dashboardModel: {
    classDashBoardDTO: {},
    lecturerDashBoardDTO: {},
    studentDashBoardDTO: {},
  },
});

// mutations
const mutations = {
  setDashboardModel(state, data) {
    state.dashboardModel = data;
  },
};

// actions
const actions = {
  async loadDashboard(vuexContext, data) {
    return await getDashboard(data).then((response) => {
      let data = response.data.data;
      let studentEducationTypeData = [
        {
          name: "Çevrimiçi",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Yüz Yüze",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Hibrit",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ];
      let monthData = [
        {
          name: "Belirtilmemiş",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Erkek",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Kadın",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ];

      data.studentLastDashBoardDTO.map((lastStudent, index) => {
        lastStudent.index = index + 1;
        lastStudent.id = index + 1;
        lastStudent.statusColor = lastStudent.status.includes("Havuz") ? "accent_darken" : "primary";
      });

      data.lecturerIdleDashBoardDTO.map((freeLecturer, index) => {
        freeLecturer.index = index + 1;
      });

      data.studentCountDashBoardDTO.map((student) => {
        let monthIndex = Number(student.addedTime.split("-")[1]);
        if (student.maleId === 1) {
          monthData[0].data[monthIndex - 1]++;
        } else if (student.maleId === 2) {
          monthData[1].data[monthIndex - 1]++;
        } else if (student.maleId === 3) {
          monthData[2].data[monthIndex - 1]++;
        }
      });

      data.educationDashBoardDTO.map((education) => {
        let monthIndex = Number(education.addedTime.split("-")[1]);
        if (education.educationId === 2) {
          studentEducationTypeData[0].data[monthIndex - 1]++;
        } else if (education.educationId === 4) {
          studentEducationTypeData[1].data[monthIndex - 1]++;
        } else if (education.educationId === 5) {
          studentEducationTypeData[2].data[monthIndex - 1]++;
        }
      });

      data.studentEducationTypeData = studentEducationTypeData;
      data.monthData = monthData;
      vuexContext.commit("setDashboardModel", data);
      return data;
    });
  },

  async setKvkkOnay(state) {
    return await setKvkk(state.rootState.auth.userInfo.id)
  }
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
